import React, { useState, useEffect } from 'react';
import logoPTS from '../PTS_Logo_jpg.jpg';

const WorkspaceSelectorModal = ({ workspaces, onSelect }) => {
    // Se tiver apenas 1, já deixa selecionado o slug dela
    const [selectedSlug, setSelectedSlug] = useState(workspaces.length === 1 ? workspaces[0].slug : "");
    
    // Identifica se o usuário é o OWNER (titular)
    const isOwner = workspaces.some(w => w.role === "OWNER");

    // Mata o fantasma do título "Certificado Digital"
    useEffect(() => {
        document.title = "PTS IA do Asfalto | Seleção de Ambiente";
    }, []);

    const handleEntry = () => {
        if (selectedSlug) onSelect(selectedSlug);
    };

    return (
        <div className="pts-modal-glass">
            <div className="pts-modal-box selector">
                
                <div className="pts-selector-header">
                    <img src={logoPTS} alt="Logo PTS" className="pts-logo-img" />
                    <div className="pts-brand-column">
                        <h2>PTS <span>IA do Asfalto</span></h2>
                        <p>Ambiente de Engenharia Digital</p>
                    </div>
                </div>

                <div className="pts-selector-content">
                    <label className="pts-label">Unidade de Trabalho</label>
                    
                    <select 
                        className="pts-dynamic-input selector-dropdown"
                        value={selectedSlug}
                        onChange={(e) => setSelectedSlug(e.target.value)}
                    >
                        <option value="" disabled>— Selecione uma unidade —</option>
                        {workspaces.map((wksp) => (
                            <option key={wksp.cnpj_completo} value={wksp.slug}>
                                {wksp.tipo_unidade === 'MATRIZ' ? '🏢' : '📍'} {wksp.nome_exibicao} ({wksp.cnpj_completo})
                            </option>
                        ))}
                    </select>

                    <button 
                        className={`pts-btn-launch ${!selectedSlug ? 'disabled' : ''}`}
                        onClick={handleEntry}
                        disabled={!selectedSlug}
                    >
                        ENTRAR NA ESTAÇÃO
                    </button>
                </div>

                <div className="pts-selector-footer">
                    {isOwner ? (
                        <p>
                            Deseja cadastrar uma nova unidade? <br/>
                            Acesse a seção de <strong>Gestão de Empresas</strong> dentro do Dashboard.
                        </p>
                    ) : (
                        <p>
                            Deseja cadastrar uma nova unidade? <br/>
                            <span>Solicite ao Sócio da empresa cadastrado como Owner.</span>
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default WorkspaceSelectorModal;